import { css, cx } from '@linaria/core';
import { colors } from '../../utils/css/index';
import { withTheme } from '../higherOrderComponents/withTheme.jsx';

export const cssVariables = {
  limitedPageLayoutBackgroundColor: '--limited-page-layout-background-color',
};

export const limitedPageClass = css`
  max-width: 1600px;
  margin: 0 auto;
`;

export const limitedPageLayoutClass = css`
  background: var(${cssVariables.limitedPageLayoutBackgroundColor}, ${colors.WHITE});
  display: grid;
`;

export const LimitedPageLayout = ({ children, className }) => (
  <div
    className={cx(limitedPageLayoutClass, limitedPageClass, className)}
    data-testId="limited-page-layout"
  >
    {children}
  </div>
);

LimitedPageLayout.darkStyles = css`
  ${cssVariables.limitedPageLayoutBackgroundColor}: ${colors.DARK_BLUE_GREY_01};
`;

export const LimitedPageLayoutWithTheme = withTheme(LimitedPageLayout)(LimitedPageLayout.darkStyles);
